import { render, staticRenderFns } from "./SelectSuppliersToContact.vue?vue&type=template&id=47221202"
import script from "./SelectSuppliersToContact.vue?vue&type=script&lang=js"
export * from "./SelectSuppliersToContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports